module.exports = __webpack_public_path__ + "img/1876.9c264f67.jpg";